module.exports = __webpack_public_path__ + "media/06patriotism.91fcf231.mp3";